module.exports = __webpack_public_path__ + "img/pr-1.dc1b8a58.png";